import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PopupDialogData } from './popup-dialog.interface';

@Component({
  selector: 'portal-dialog-popup',
  templateUrl: './popup-dialog.component.html',
  styleUrls: ['./popup-dialog.component.scss'],
  standalone: false,
})
export class PopupDialogComponent {
  dialogRef = inject<MatDialogRef<PopupDialogComponent>>(MatDialogRef);
  data = inject<PopupDialogData>(MAT_DIALOG_DATA);

  cancelClick(): void {
    this.dialogRef.close();
  }
}
